import React from 'react';
import { ArrowRight, Sparkles, CheckCircle, Calendar } from 'lucide-react';

interface MobileHeroProps {
  onChatOpen?: () => void;
  onProjectSubmit?: () => void;
  onAppointmentBook?: () => void;
}

const MobileHero: React.FC<MobileHeroProps> = ({ onChatOpen, onProjectSubmit, onAppointmentBook }) => {
  const features = [
    'Développement sur mesure',
    'Technologies modernes',
    'Support continu',
    'Livraison rapide'
  ];
  return (
    <section className="relative overflow-hidden">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-gray-800 to-amber-900/20" />
      
      {/* Background Image avec overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{ backgroundImage: 'url(/baniere.jpg)' }}
      />

      {/* Content */}
      <div className="relative px-4 py-10">
        <div className="text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-white/10 backdrop-blur-sm rounded-full text-amber-200 text-xs font-medium mb-4">
            <Sparkles className="w-3 h-3" />
            Solutions digitales sur mesure
          </div>

          {/* Titre Principal */}
          <h1 className="text-3xl font-bold text-white mb-3 leading-tight">
            Transformez vos idées
            <span className="block bg-gradient-to-r from-amber-300 to-amber-500 bg-clip-text text-transparent">
              en réalité digitale
            </span>
          </h1>

          {/* Description */}
          <p className="text-sm text-gray-300 mb-6 max-w-sm mx-auto leading-relaxed">
            Applications web, mobiles et solutions IA pour propulser votre business vers le succès
          </p>

          {/* CTAs Compacts */}
          <div className="flex gap-2 max-w-sm mx-auto mb-6">
            <button
              onClick={onProjectSubmit}
              className="flex-1 py-2.5 px-3 bg-gradient-to-r from-amber-500 to-amber-600 text-white rounded-lg font-medium text-sm shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-center gap-1.5"
            >
              <span>Soumettre un projet</span>
              <ArrowRight className="w-3.5 h-3.5" />
            </button>
            
            <button
              onClick={onAppointmentBook}
              className="flex-1 py-2.5 px-3 bg-gradient-to-r from-amber-500 to-amber-600 text-white rounded-lg font-medium text-sm shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-center gap-1.5"
            >
              <Calendar className="w-3.5 h-3.5" />
              <span>Rendez-vous</span>
            </button>
          </div>


          {/* Features Grid */}
          <div className="grid grid-cols-2 gap-2 max-w-sm mx-auto">
            {features.map((feature, index) => (
              <div key={index} className="flex items-center gap-1.5 text-left">
                <CheckCircle className="w-3 h-3 text-amber-400 flex-shrink-0" />
                <span className="text-xs text-gray-200">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MobileHero;
